import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { adminLoginSuccess, updateAdminProfile } from "../store/authSlice";
import { isEmailValid } from "../utils/security";
import { adminLogin as adminLoginRequest } from "../services/portalApi";
import RenderToast from "../components/RenderToast";
import styles from "./AdminLoginPage.module.css";
import bg from "../assets/banner/rcm-bg.webp";

export default function AdminLoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const update = (name) => (event) =>
    setForm((prev) => ({ ...prev, [name]: event.target.value }));

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!form.email || !form.password) {
      RenderToast({
        type: "error",
        message: "Email and password are required.",
      });
      return;
    }
    if (!isEmailValid(form.email)) {
      RenderToast({
        type: "error",
        message: "Please enter a valid email address.",
      });
      return;
    }

    setLoading(true);
    adminLoginRequest(form.email, form.password)
      .then((result) => {
        dispatch(adminLoginSuccess({ token: result.token || "admin-token" }));
        if (result.admin) {
          dispatch(
            updateAdminProfile({
              id: result.admin.id,
              name: result.admin.name,
              email: result.admin.email,
              role: result.admin.role,
              mustUpdateCredentials: Boolean(
                result.admin.mustUpdateCredentials,
              ),
            }),
          );
        }
        RenderToast({
          type: "success",
          message: result.message || "Admin login successful",
        });
        navigate("/admin/dashboard");
      })
      .catch((error) => {
        RenderToast({
          type: "error",
          message: error.message || "Invalid credentials",
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <div
      className={styles.wrap}
      style={{
        background: `url(${bg})`,
      }}
    >
      <div className={`${styles.card} pageCard`}>
        <img
          src="/logo/rcmLogo.webp"
          alt="RCM Portal"
          className={styles.logo}
        />
        {/* <h1>Admin Login</h1> */}
        <p className="muted">Sign in to manage users and portal settings.</p>
        <form className={styles.form} onSubmit={handleSubmit}>
          <label className={styles.field}>
            <span>Email</span>
            <input
              className="inputBase"
              value={form.email}
              onChange={update("email")}
              placeholder="Email address"
            />
          </label>
          <PasswordField value={form.password} onChange={update("password")} />
          <button
            type="submit"
            className="btnBase btnPrimary"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}

function PasswordField({ value, onChange }) {
  const [show, setShow] = React.useState(false);

  return (
    <label className={styles.field}>
      <span>Password</span>
      <div className={styles.passwordWrap}>
        <input
          className="inputBase"
          type={show ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder="Password"
        />
        <button
          type="button"
          className={styles.eye}
          onClick={() => setShow((v) => !v)}
        >
          {show ? <FiEyeOff /> : <FiEye />}
        </button>
      </div>
    </label>
  );
}
